import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import Navigation from "../Navigation";

import Destination from "./Destination";
import Passenger from "./Passenger";
import Luggage from "./Luggage";
import Details from "./Details";
import BookingModel from "../../model/BookingModel";
import DestinationModel from "../../model/DestinationModel";
import { calculateFareAmount } from "../../components/fareCalculation";
import { consumerId, GENERATE_HASH, key, LOG_TRANSACTION, merchantId, REDIRECT_URL } from "../../config/constants";
import axios from "axios";

export default function Booking() {
  const [step, setStep] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isWeightExceeded, setIsWeightExceeded] = useState(false);
  const [showNotification, setShowNotification] = useState(false);



  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.type = "text/javascript";
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    const loadScripts = async () => {
      try {
        await loadScript("https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js");
        await loadScript("https://www.paynimo.com/paynimocheckout/server/lib/checkout.js");
      } catch (error) {
        console.error("Error loading scripts:", error);
      }
    };

    loadScripts();
  }, []);

  const [formData, setFormData] = useState({
    tripDate: "",
    login: sessionStorage.getItem('id'),
    counter: "WEB",
    standCounter: "",
    type: "N",
    vehicleCategory: "",
    passengerName: sessionStorage.getItem('name') || "",
    passengerPhone: sessionStorage.getItem('contact') || "",
    passengerEmail: sessionStorage.getItem('email') || "",
    destination: "",
    tripDistance: 0,
    adjustedAmount: 0,
    fareAmount: 0,
    amount: 0,
    surcharge: 0,
    cgst: 0,
    sgst: 0,
    tollCharge: 0,
    serviceTax: 0,
    totalAmount: 0,
    amountReceived: 0,
    waitingCharge: 0,
    highRangeCharge: 0,
    vehicleRate: 0,
    adjustDistance: "",
    waitMinute: "",
    tollDescription: "",
    cardCharge: 0,
    requestReferenceNo: 0,
    peakTimeCharge: 0,
    receiptNo: 0,
    description: "",
    passengerCount: "1",
    kidsCount: "0",
    largeBag: 0,
    mediumBag: 0,
    cabinBag: 0
  });
  const validateStep = () => {
    let errors = {};
    if (step === 1) {
      if (!formData.standCounter) errors.standCounter = "Terminal is required";
    if (!formData.destination) {
      errors.destination = "Destination is required";
    } else {
      const destinations = DestinationModel.getDestinations() || [];
      const trimmedDestination = formData.destination.trim();
      const isValidDestination = destinations.some(
        (dest) => dest.name.trim().toLowerCase() === trimmedDestination.toLowerCase()
      );

      if (!isValidDestination) {
        errors.destination = "Please select a destination from the list.";
      }
    }
      if (!formData.tripDate) errors.tripDate = "Trip Date is required";
      // if (!formData.waitMinute) errors.waitMinute = "Wait Minute is required";
      // if (!formData.adjustDistance) errors.adjustDistance = "Adjust Distance is required";
    } else if (step === 2) {
      if (!formData.passengerName) errors.passengerName = "Passenger Name is required";
      if (!formData.passengerEmail) errors.passengerEmail = "Passenger Email is required";
      if (!formData.passengerPhone) errors.passengerPhone = "Passenger Phone is required";
      if (!formData.passengerCount) errors.passengerCount = "Passenger Count is required";
      if (!formData.kidsCount) errors.kidsCount = "Kids Count is required";
    } else if (step === 3) {
      if (formData.largeBag === "") errors.largeBag = "Large bag count is required";
      if (formData.mediumBag === "") errors.mediumBag = "Medium bag count is required";
      if (formData.cabinBag === "") errors.cabinBag = "Cabin bag count is required";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const nextStep = () => {
    if (validateStep()) {
      setStep((prev) => Math.min(prev + 1, 4));
      BookingModel.destination = formData.destination;
      BookingModel.passengerName = formData.passengerName;
      BookingModel.passengerPhone = formData.passengerPhone;
      BookingModel.passengerEmail = formData.passengerEmail;
      BookingModel.tripDate = formData.tripDate;
      BookingModel.standCounter = formData.standCounter;
      BookingModel.adjustDistance = formData.adjustDistance;
      BookingModel.waitMinute = formData.waitMinute;
      BookingModel.passengerCount = formData.passengerCount;
      BookingModel.kidsCount = formData.kidsCount;
      BookingModel.largeBag = formData.largeBag;
      BookingModel.mediumBag = formData.mediumBag;
      BookingModel.cabinBag = formData.cabinBag;
      BookingModel.login = formData.login;
      BookingModel.cgst = formData.cgst;
      BookingModel.sgst = formData.sgst;
      BookingModel.counter = formData.counter;
      BookingModel.surcharge = formData.surcharge;
      BookingModel.totalAmount = formData.totalAmount;
      BookingModel.waitingCharge = formData.waitingCharge;
      calculateFareAmount();
      setValidationErrors({});
    }
  };

  const prevStep = () => {
    setStep((prev) => Math.max(prev - 1, 1));
  };

  const icons = [
    "fa-solid fa-location-dot",
    "fa-solid fa-user",
    "fa-solid fa-suitcase",
    "fa-solid fa-file-alt"
  ];

  const logTransaction = async (logData) => {
    try {
      await axios.post(LOG_TRANSACTION, logData);
    } catch (error) {
      console.error("Error logging transaction:", error);
    }
  };
  const generateHash = async (dataString) => {
    try {
      const response = await axios.post(GENERATE_HASH, { data: dataString });
      return response.data.hash;
    } catch (err) {
      return err;
    }
  };

  const handleResponse = async (res) => {
    if (
      res &&
      res.paymentMethod &&
      res.paymentMethod.paymentTransaction &&
      res.paymentMethod.paymentTransaction.statusCode
    ) {
      const statusCode = res.paymentMethod.paymentTransaction.statusCode;
      const logData = {
        txnId: res.txnId || "Unknown",
        requestDetails: null,
        responseDetails: res,
        status: statusCode === "0300" ? "Success" : statusCode === "0398" ? "Initiated" : "Failed",
        timestamp: new Date().toISOString(),
      };
      await logTransaction(logData);
      if (statusCode === "0300") {
        console.log("Transaction Successful:", res);
      } else if (statusCode === "0398") {
        console.log("Transaction Initiated:", res);
      } else {
        console.error("Transaction Failed:", res);
      }
    } else {
      console.error("Invalid Response:", res);
    }
    setIsPayment(false);

  };

  const handlePayment = async (txnId) => {
    const amount = BookingModel.totalAmount;
    const dataString = `${merchantId}|${txnId}|${amount}||${consumerId}||||||||||||${key}`;

    const hash = await generateHash(dataString);

    if (!hash) {
      alert("Failed to generate payment token. Please try again.");
      setIsPayment(false);
      return;
    }
    const reqJson = {
      features: {
        enableAbortResponse: true,
        enableExpressPay: true,
        enableInstrumentDeRegistration: true,
        enableMerTxnDetails: true,
      },
      consumerData: {
        deviceId: "WEBSH2",
        token: hash,
        returnUrl: `${REDIRECT_URL}`,
        responseHandler: handleResponse,
        paymentMode: "all",
        merchantLogoUrl: "https://www.cial.aero/images/logo.png",
        merchantId: merchantId,
        currency: "INR",
        consumerId: consumerId,
        txnId: txnId,
        items: [
          {
            itemId: "first",
            amount: amount,
            comAmt: "0",
          },
        ],
        customStyle: {
          PRIMARY_COLOR_CODE: "#ADC045",
          SECONDARY_COLOR_CODE: "#FFFFFF",
          BUTTON_COLOR_CODE_1: "#34B233",
          BUTTON_COLOR_CODE_2: "#FFFFFF",
        },
      },
    };
    await logTransaction({
      txnId,
      requestDetails: reqJson,
      responseDetails: null,
      status: "Transaction Initiated",
      timestamp: new Date().toISOString(),
    });

    window.$.pnCheckout(reqJson);
    if (reqJson.features.enableNewWindowFlow) {
      window.pnCheckoutShared.openNewWindow();
    }
  };

  const handleSubmit = async () => {
    if (!isChecked) {
      alert("You must accept the Terms & Conditions before proceeding.");
      return;
    }
    setIsPayment(true);
    const response = await BookingModel.createBooking();
    sessionStorage.setItem("bookingId", response.data.no);
    handlePayment(response.data.no);
  }


  return (
    <div>
      <Navigation />
      <div className="booking-step-container ">
        <h1>Book Your <span>Taxi</span></h1>
        <div className="stepper">
          <div className="progress-bar">
            <div className="progress-line" style={{ width: `${(step - 1) * 33}%` }}></div>
          </div>
          {icons.map((icon, index) => (
            <div
              key={index}
              className={`step ${step === index + 1 ? "active" : ""} ${step > index + 1 ? "completed" : ""}`}>
              <i className={icon}></i>
            </div>
          ))}
        </div>
        <div className="inner-div">
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
          >
            {step === 1 && <Destination validationErrors={validationErrors} formData={formData} setFormData={setFormData} />}
            {step === 2 && <Passenger showNotification={showNotification} setShowNotification={setShowNotification} validationErrors={validationErrors} formData={formData} setFormData={setFormData} />}
            {step === 3 && <Luggage isWeightExceeded={isWeightExceeded} setIsWeightExceeded={setIsWeightExceeded} validationErrors={validationErrors} formData={formData} setFormData={setFormData} />}
            {step === 4 && <Details validationErrors={validationErrors} formData={formData} setFormData={setFormData} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}
          </motion.div>
        </div>
        <div className="buttons">
          <div className="left">
            {step < 4 ? (
              <button className={isWeightExceeded || showNotification ? "disabled-btn" : "confirm-btn"} disabled={isWeightExceeded || showNotification} onClick={nextStep}>Continue</button>
            ) : (
              <button className={!isChecked ? "disabled-btn" : "confirm-btn"} onClick={handleSubmit} >Confirm Booking</button>
            )}
            {step > 1 && <button className="back" onClick={prevStep}>Go Back</button>}
          </div>
          <div className="right">
            {step === 4 && (
              <>
                <div className="terms-conditions">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                  />
                  <span>I agree to the <span className="terms-link" onClick={() => setIsTermsModalOpen(true)}>Terms & Conditions</span></span>
                </div>
                <button onClick={() => setIsModalOpen(true)}>
                  <i className="fa-solid fa-exclamation"></i> View Fare Details
                </button>
              </>
            )}
          </div>
        </div>
        {isTermsModalOpen && (
          <div className="tmodal" onClick={() => setIsTermsModalOpen(false)}>
            <div className="tmodal-content">
              <button className="close-button" onClick={() => setIsTermsModalOpen(false)}>✖</button>
              <h2>TERMS & CONDITIONS</h2>
              <p>
                Welcome to CIAL online prepaid taxi booking  website. If you continue to browse and use this website, you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy. If you disagree with any part of these terms and conditions, please do not use our website.
              </p>
              <h3>TERMS OF USE:</h3>
              <p>
                The use of this website is subject to the following terms of use: <br /><br />

                The content of the pages of this website is for your general information and use only.
                It is subject to change without notice.<br /><br />

                This website uses cookies to monitor browsing preferences.
                If you do allow cookies to be used, the following personal information may be stored
                by us for use by third parties: IP Address, Location.<br /><br />

                Neither we nor any third parties provide any warranty or guarantee as to the accuracy,
                timeliness, performance, completeness or suitability of the information and materials found or
                offered on this website for any particular purpose. You acknowledge that such information and
                materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies
                or errors to the fullest extent permitted by law.<br /><br />

                Your use of any information or materials on this website is entirely at your own risk, for which we
                shall not be liable. It shall be your own responsibility to ensure that any products, services or
                information available through this website meet your specific requirements.<br /><br />

                This website contains material which is owned by or licensed to us. This material includes,
                but is not limited to, the design, layout, look, appearance and graphics. Reproduction is
                prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.<br /><br />
                All trademarks reproduced in this website which are not the property of, or licensed to,
                the operator are acknowledged on the website.<br /><br />

                Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offence.<br /><br />

                From time to time this website may also include links to other websites. These links are provided
                for your convenience to provide further information. They do not signify that we endorse the website(s).
                We have no responsibility for the content of the linked website(s).<br /><br />

                Your use of this website and any dispute arising out of such use of the website is subject to the
                laws of India.<br /><br />

                Specific offers will have might have additional Terms & Conditions which the user has to
                comply with in case he chooses to avail that offer.<br /><br />

              </p>
              <h3>PRIVACY POLICY</h3>
              <p>
                We respect your privacy and recognize the need to protect the personal information you have
                provided at the time of booking.<br /><br />

                intends to make clear its intention of collecting your data. Generally, at the time of booking,
                you don’t have to provide any personally identifiable data except your name and phone number.
                However, there will be some limitations on on-site usage regarding special offers, discounts, etc.<br /><br />

              </p>
              <h3>WHAT DO WE DO WITH YOUR INFORMATION?</h3>
              <p>
                When you choose to avail of our services, we collect the personal information you give us such
                as your name, address, and email address. When you browse our store, we also automatically receive
                your computer’s internet protocol (IP) address in order to provide us with information that
                helps us learn about your browser and operating system.<br /><br />

                Email marketing: With your permission, we may send you emails about our store, new products,
                and other updates.<br /><br />

              </p>
              <h3>CONSENT</h3>
              <p>
                When you provide us with personal information to complete a transaction, verify your credit
                card, place an order, arrange for a delivery or return a purchase, we imply that you consent
                to our collecting it and using it for that specific reason only.<br /><br />

                If we ask for your personal information for a secondary reason, like marketing, we will either
                ask you directly for your expressed consent or provide you with an opportunity to say no.<br /><br />

              </p>
              <h3>HOW DO I WITHDRAW MY CONSENT?</h3>
              <p>
                If after you opt-in, you change your mind, you may withdraw your consent for us to contact
                you, for the continued collection, use, or disclosure of your information, at any time, by
                mailing us at ciatocs@cial.aero<br /><br />

              </p>
              <h3>DEVICE INFORMATION:</h3>
              <p>
                The company collects information about the mobile devices, including the hardware model,
                operating system and version, software and file names and versions, preferred language,
                unique device identifier, advertising identifiers, serial number, device motion information,
                and mobile network information.<br /><br />

              </p>
              <h3>DISCLOSURE</h3>
              <p>
                We may disclose your personal information if we are required by law to do so or if you
                violate our Terms of Service.<br /><br />

              </p>
              <h3>THIRD-PARTY SERVICES</h3>
              <p>
                In general, the third-party providers used by us will only collect, use and disclose your
                information to the extent necessary to allow them to perform the services they provide
                to us.<br /><br />

                However, certain third-party service providers, such as payment gateways and other
                payment transaction processors, have their own privacy policies with respect to the
                information we are required to provide to them for your purchase-related transactions.<br /><br />

                For these providers, we recommend that you read their privacy policies so you can
                understand the manner in which your personal information will be handled by these
                providers.<br /><br />

                In particular, remember that certain providers may be located in or have facilities
                that are located in a different jurisdiction than either you or us. So if you elect to
                proceed with a transaction that involves the services of a third-party service provider,
                then your information may become subject to the laws of the jurisdiction(s) in which
                that service provider or its facilities are located.<br /><br />

                As an example, if you are located in India and your transaction is processed by a
                payment gateway located outside India, then your personal information used in
                completing that transaction may be subject to disclosure under that particular
                country’s norms.<br /><br />

                Once you leave our  website or are redirected to a third-party website or
                application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.
              </p>
              <h3>SECURITY</h3>
              <p>
                To protect your personal information, we take reasonable precautions and follow
                industry best practices to make sure it is not inappropriately lost, misused,
                accessed, disclosed, altered, or destroyed.<br /><br />

              </p>
              <h3>CHANGES TO THIS PRIVACY POLICY</h3>
              <p>
                Reserves the right to modify this privacy policy at any time, so please review
                it frequently. Changes and clarifications will take effect immediately upon
                their posting on the website. If we make material changes to this policy,
                we will notify you here that it has been updated, so that you are aware of
                what information we collect, how we use it, and under what circumstances,
                if any, we use and/or disclose it.<br /><br />

              </p>
              <h3>LOG INFORMATION:</h3>
              <p>
                The company also collects server logs, which may include information like
                device IP address, access dates and times, app features or pages viewed,
                app crashes and other system activity, type of browser, and the third-party
                site or service the User was using before interacting with Company’s Services.<br /><br />

                In the case of any confirmations or queries  via call centre, Company may
                record calls for quality and training purposes.<br /><br />

              </p>
              <h3> BOOKING POLICY</h3>
              <p>
                Prepaid taxi can be booked 30 days in advance through the customer login
                area. Booking can be possible with minimum passenger and baggage count
                only, any specific vehicle selection required need to be done through
                self-service kiosk or prepaid taxi counter only.<br /><br />

                Online reserved passengers are mandatorily use the KIOSK or prepaid taxi
                counter to get the vehicle allocated.
              </p>
              <h3> BOOKING MODIFICATIONS</h3>
              <p>
                Only travelling date modifications are possible through web, no destination
                change allowed. Any such destination changes needs to be done through the
                prepaid taxi counter at the airport. There is no time limit to modify the online reservations.<br /><br />

              </p>
              <h3>BOOKING CANCELLAITONS</h3>
              <p>
                Online reservations can be cancelled through web and prepaid taxi counters.
                There is no cancellation charges collected except the card charges collected, if any.<br /><br />

              </p>
              <h3>VEHICLE ALLOTEMENT</h3>
              <p>
                Online booking will facilitate only the allocation of vehicle which is available
                in turn position, irrespective of the vehicle type and seating capacity. No
                specific vehicle type selection possible through online reservation.<br /><br />

              </p>
              <h3>REFUND POLICY</h3>
              <p>
                All refund requests are processed within 5-7 business days, and payments are
                always done via the original source of payment for booking the taxi. The refund
                requests will be automatically logged on cancellation.<br /><br />

              </p>
            </div>
          </div>
        )}
        {
          isPayment && (
            <div className="payment-loader">
              <div className="loader">
              </div>
            </div>
          )
        }
      </div>

    </div>
  );
}
